const namespace = 'bravissimo/gdpr/';

export const GDPR_CONTENT_REQUEST = `${namespace}GDPR_CONTENT_REQUEST`;
export const GDPR_CONTENT_SUCCESS = `${namespace}GDPR_CONTENT_SUCCESS`;
export const GDPR_CONTENT_FAILURE = `${namespace}GDPR_CONTENT_FAILURE`;
export const UPDATE_TERMS_DECISION = `${namespace}UPDATE_TERMS_DECISION`;
